import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { ProgressBar } from '../components/ui/ProgressBar';
import { SettingsIcon, EditIcon, AwardIcon, MapPinIcon, CalendarIcon, UserIcon, GlobeIcon, InstagramIcon, FacebookIcon, TwitterIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Profile: React.FC = () => {
  return <div data-id="element-1331">
      <div className="flex justify-between items-center mb-5" data-id="element-1332">
        <h1 className="text-xl sm:text-2xl font-bold text-navy" data-id="element-1333">Profile</h1>
        <Link to="/settings" data-id="element-1334">
          <Button variant="outline" size="sm" icon={<SettingsIcon size={16} data-id="element-1336" />} data-id="element-1335">
            Settings
          </Button>
        </Link>
      </div>
      <Card className="mb-5" data-id="element-1337">
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4" data-id="element-1338">
          <div className="relative" data-id="element-1339">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80" alt="Profile" className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover" data-id="element-1340" />
            <button className="absolute bottom-0 right-0 bg-primary text-white rounded-full p-1" data-id="element-1341">
              <EditIcon size={14} data-id="element-1342" />
            </button>
          </div>
          <div className="flex-1 text-center sm:text-left" data-id="element-1343">
            <h2 className="text-xl font-bold" data-id="element-1344">Alex Johnson</h2>
            <p className="text-gray-600 flex items-center justify-center sm:justify-start" data-id="element-1345">
              <MapPinIcon size={16} className="mr-1" data-id="element-1346" />
              Sydney, Australia
            </p>
            <p className="text-gray-600 flex items-center justify-center sm:justify-start" data-id="element-1347">
              <CalendarIcon size={16} className="mr-1" data-id="element-1348" />
              Member since June 2021
            </p>
            <div className="flex flex-wrap gap-2 mt-2 justify-center sm:justify-start" data-id="element-1349">
              <Badge variant="primary" data-id="element-1350">Advanced Diver</Badge>
              <Badge variant="secondary" data-id="element-1351">Instructor</Badge>
              <Badge variant="accent" data-id="element-1352">Photographer</Badge>
            </div>
          </div>
          <div className="flex gap-2 mt-2 sm:mt-0" data-id="element-1353">
            <Button variant="outline" size="sm" icon={<EditIcon size={16} data-id="element-1355" />} data-id="element-1354">
              Edit Profile
            </Button>
          </div>
        </div>
      </Card>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-6 mb-5" data-id="element-1356">
        <Card data-id="element-1357">
          <h3 className="font-semibold mb-4 flex items-center" data-id="element-1358">
            <AwardIcon size={18} className="mr-2 text-primary" data-id="element-1359" />
            Certifications
          </h3>
          <div className="space-y-4" data-id="element-1360">
            <div className="border-b pb-3" data-id="element-1361">
              <div className="flex justify-between" data-id="element-1362">
                <div data-id="element-1363">
                  <p className="font-medium" data-id="element-1364">Open Water Diver</p>
                  <p className="text-sm text-gray-500" data-id="element-1365">PADI</p>
                </div>
                <Badge variant="success" data-id="element-1366">Completed</Badge>
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1367">June 2021</p>
            </div>
            <div className="border-b pb-3" data-id="element-1368">
              <div className="flex justify-between" data-id="element-1369">
                <div data-id="element-1370">
                  <p className="font-medium" data-id="element-1371">Advanced Open Water</p>
                  <p className="text-sm text-gray-500" data-id="element-1372">PADI</p>
                </div>
                <Badge variant="success" data-id="element-1373">Completed</Badge>
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1374">August 2021</p>
            </div>
            <div data-id="element-1375">
              <div className="flex justify-between" data-id="element-1376">
                <div data-id="element-1377">
                  <p className="font-medium" data-id="element-1378">Rescue Diver</p>
                  <p className="text-sm text-gray-500" data-id="element-1379">PADI</p>
                </div>
                <Badge variant="primary" data-id="element-1380">In Progress</Badge>
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1381">65% Complete</p>
              <ProgressBar value={65} variant="primary" size="sm" className="mt-2" data-id="element-1382" />
            </div>
          </div>
          <Button variant="outline" fullWidth className="mt-4" data-id="element-1383">
            View All
          </Button>
        </Card>
        <Card data-id="element-1384">
          <h3 className="font-semibold mb-4" data-id="element-1385">Dive Stats</h3>
          <div className="grid grid-cols-2 gap-4" data-id="element-1386">
            <div data-id="element-1387">
              <p className="text-sm text-gray-500" data-id="element-1388">Total Dives</p>
              <p className="text-2xl font-bold text-primary" data-id="element-1389">86</p>
            </div>
            <div data-id="element-1390">
              <p className="text-sm text-gray-500" data-id="element-1391">Dive Time</p>
              <p className="text-2xl font-bold text-primary" data-id="element-1392">64h</p>
            </div>
            <div data-id="element-1393">
              <p className="text-sm text-gray-500" data-id="element-1394">Max Depth</p>
              <p className="text-2xl font-bold text-primary" data-id="element-1395">42m</p>
            </div>
            <div data-id="element-1396">
              <p className="text-sm text-gray-500" data-id="element-1397">Countries</p>
              <p className="text-2xl font-bold text-primary" data-id="element-1398">7</p>
            </div>
          </div>
          <div className="mt-4" data-id="element-1399">
            <h4 className="text-sm font-medium mb-2" data-id="element-1400">Recent Achievements</h4>
            <div className="flex gap-2" data-id="element-1401">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary" data-id="element-1402">
                <AwardIcon size={24} data-id="element-1403" />
              </div>
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center text-secondary" data-id="element-1404">
                <GlobeIcon size={24} data-id="element-1405" />
              </div>
              <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center text-accent" data-id="element-1406">
                <UserIcon size={24} data-id="element-1407" />
              </div>
            </div>
          </div>
          <Button variant="outline" fullWidth className="mt-4" data-id="element-1408">
            View All Stats
          </Button>
        </Card>
        <Card data-id="element-1409">
          <h3 className="font-semibold mb-4" data-id="element-1410">About Me</h3>
          <p className="text-gray-700 mb-4" data-id="element-1411">
            Passionate diver with a love for underwater photography. I've been
            diving for 2 years and enjoy exploring coral reefs and marine life
            around Australia and Southeast Asia.
          </p>
          <div className="mb-4" data-id="element-1412">
            <h4 className="text-sm font-medium mb-2" data-id="element-1413">Interests</h4>
            <div className="flex flex-wrap gap-2" data-id="element-1414">
              <Badge variant="primary" data-id="element-1415">Underwater Photography</Badge>
              <Badge variant="primary" data-id="element-1416">Marine Conservation</Badge>
              <Badge variant="primary" data-id="element-1417">Wreck Diving</Badge>
              <Badge variant="primary" data-id="element-1418">Night Diving</Badge>
            </div>
          </div>
          <div data-id="element-1419">
            <h4 className="text-sm font-medium mb-2" data-id="element-1420">Connect</h4>
            <div className="flex gap-3" data-id="element-1421">
              <a href="#" className="text-gray-600 hover:text-primary" data-id="element-1422">
                <InstagramIcon size={20} data-id="element-1423" />
              </a>
              <a href="#" className="text-gray-600 hover:text-primary" data-id="element-1424">
                <FacebookIcon size={20} data-id="element-1425" />
              </a>
              <a href="#" className="text-gray-600 hover:text-primary" data-id="element-1426">
                <TwitterIcon size={20} data-id="element-1427" />
              </a>
            </div>
          </div>
        </Card>
      </div>
      <Card data-id="element-1428">
        <div className="flex justify-between items-center mb-4" data-id="element-1429">
          <h3 className="font-semibold" data-id="element-1430">Recent Dives</h3>
          <Button variant="outline" size="sm" icon={<ChevronRightIcon size={16} data-id="element-1432" />} data-id="element-1431">
            View All
          </Button>
        </div>
        <div className="overflow-x-auto -mx-4 sm:-mx-5 px-4 sm:px-5" data-id="element-1433">
          <div className="min-w-[600px]" data-id="element-1434">
            <table className="w-full" data-id="element-1435">
              <thead data-id="element-1436">
                <tr className="border-b" data-id="element-1437">
                  <th className="text-left py-2 px-3 text-sm font-medium text-gray-500" data-id="element-1438">
                    Date
                  </th>
                  <th className="text-left py-2 px-3 text-sm font-medium text-gray-500" data-id="element-1439">
                    Location
                  </th>
                  <th className="text-left py-2 px-3 text-sm font-medium text-gray-500" data-id="element-1440">
                    Depth
                  </th>
                  <th className="text-left py-2 px-3 text-sm font-medium text-gray-500" data-id="element-1441">
                    Duration
                  </th>
                  <th className="text-left py-2 px-3 text-sm font-medium text-gray-500" data-id="element-1442">
                    Type
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1443">
                <tr className="border-b" data-id="element-1444">
                  <td className="py-2 px-3" data-id="element-1445">June 15, 2023</td>
                  <td className="py-2 px-3" data-id="element-1446">Great Barrier Reef</td>
                  <td className="py-2 px-3" data-id="element-1447">18m</td>
                  <td className="py-2 px-3" data-id="element-1448">45 min</td>
                  <td className="py-2 px-3" data-id="element-1449">
                    <Badge variant="primary" data-id="element-1450">Boat Dive</Badge>
                  </td>
                </tr>
                <tr className="border-b" data-id="element-1451">
                  <td className="py-2 px-3" data-id="element-1452">May 22, 2023</td>
                  <td className="py-2 px-3" data-id="element-1453">Blue Corner, Palau</td>
                  <td className="py-2 px-3" data-id="element-1454">30m</td>
                  <td className="py-2 px-3" data-id="element-1455">52 min</td>
                  <td className="py-2 px-3" data-id="element-1456">
                    <Badge variant="primary" data-id="element-1457">Drift Dive</Badge>
                  </td>
                </tr>
                <tr data-id="element-1458">
                  <td className="py-2 px-3" data-id="element-1459">April 10, 2023</td>
                  <td className="py-2 px-3" data-id="element-1460">Molokini Crater, Maui</td>
                  <td className="py-2 px-3" data-id="element-1461">15m</td>
                  <td className="py-2 px-3" data-id="element-1462">38 min</td>
                  <td className="py-2 px-3" data-id="element-1463">
                    <Badge variant="primary" data-id="element-1464">Boat Dive</Badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-4 pt-2 md:hidden" data-id="element-1465">
          <Button variant="outline" fullWidth data-id="element-1466">
            View All Dives
          </Button>
        </div>
      </Card>
    </div>;
};